/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    journalEvent?: BioExamResultsReceivedJournalEvent;
    patient?: unknown;
  };
}

import { service } from "@ember/service";
import Component from "@glimmer/component";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class FileAttachmentsCellComponent extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  get hlaRoute(): string {
    return this.session.patient
      ? "patient-web.protected.hla.consult"
      : "medics-web.protected.patients.patient.hla.consult";
  }
}
